export default function Title({
  title,
  description,
}: {
  title: string;
  description?: string;
}) {
  return (
    <h3 className="text-lg font-bold">
      {title}
      {description && (
        <span className="text-base text-stone-800 ml-2 font-medium">
          ({description})
        </span>
      )}
    </h3>
    // https://stackoverflow.com/questions/70203473/creating-a-horizontal-rule-hr-divider-that-contains-text-with-tailwind-css
    // <div className="relative flex py-3 items-center">
    //   <div className="flex-grow border-t border-black"></div>
    //   <span className="flex-shrink mx-4 text-black">{title}</span>
    //   <div className="flex-grow border-t border-black"></div>
    // </div>
  );
}
